import { render } from "./CurrentVoteStatus.vue?vue&type=template&id=1b73d0f4&scoped=true"
import script from "./CurrentVoteStatus.vue?vue&type=script&lang=js"
export * from "./CurrentVoteStatus.vue?vue&type=script&lang=js"

import "./CurrentVoteStatus.vue?vue&type=style&index=0&id=1b73d0f4&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b73d0f4"]])

export default __exports__